export default [{
  path: '/settingApp',
  name: 'settingApp',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/settingApp/setting'),
}]
